import { Fragment, useState, useEffect, useRef } from 'react';
import Link from 'next/link';
import key from 'weak-key';
import SiteSettings from '~/siteSettings';
import LinkTracker from '~/components/linkTracker/linkTracker';

/**
 * Sub Menu
 * @category Functional Component
 * @summary Displays the card block.
 * @prop {object} content - The blocks content.
 * @return {Node} React node containing the card block.
 */

const SubMenu = props => {
  const { content } = props;
  const [isSubVisible, setIsSubVisible] = useState(true);
  const [count, setCount] = useState(10);
  const tick = useRef(false);
  const totalCount = content.length;
  const _items = content?.children;

  const toggleSubIsVisible = () => {
    setIsSubVisible(!isSubVisible);
  }

  useEffect(() => {
    // On Init
    setCount(window.innerWidth < SiteSettings.jsBreakpoints.xs ? 5 : 15);

    const onResize = () => {
      const width = window.innerWidth;

      if (!tick.current) {
        window.requestAnimationFrame(() => {
          setCount(width < SiteSettings.jsBreakpoints.xs ? 5 : 15);

          tick.current = false;
        });

        tick.current = true;
      }
    }

    // If we are on the recipes hub, add a link to the recipe tags page
    if(content.tid === 4088) {
      _items.splice(0, 0, {
        field_hide_from_content_hub: false,
        name: 'Recipes',
        path: '/tags/recipes',
      });
    }

    window.addEventListener('resize', onResize, true);
    return async () => {
      window.removeEventListener('resize', onResize, true);
    };
  }, [_items, content]);

  return (
    <div className='constrain no-padding'>
      <ul className='submenu'>
        { _items.map((child, i) => (
          <Fragment key={`slide-item-${key(child)}`}>
            { !child.field_hide_from_content_hub &&
              <li className={ i > (count - 1) && isSubVisible ? 'visuallyhidden' : '' }>
                <LinkTracker
                  destinationUrl={ child.path }
                  linkCta={ child.name.toLowerCase() }
                  linkFormat='text'
                  linkRegion='hero'
                  linkSubRegion='submenu'
                >
                  <Link href={ child.path } passHref>
                    <a
                      aria-label={`Visit ${ child.name }`}
                      data-autotrack='false'
                    >
                      { child.name }
                    </a>
                  </Link>
                </LinkTracker>
              </li>
            }
          </Fragment>
        ))}
        { totalCount > count &&
          <li>
            <LinkTracker
              destinationUrl=''
              linkCta='see more'
              linkFormat='button'
              linkRegion='hero'
              linkSubRegion='submenu'
            >
              <button
                className='submenu__see-all'
                type='button'
                aria-label='See All'
                onClick={ toggleSubIsVisible }
                data-autotrack='false'
              >
                { isSubVisible ? <>See More</> : <>See Less</> }
              </button>
            </LinkTracker>
          </li>
        }
      </ul>
    </div>
  );
}

export default SubMenu;
